// src/components/Unauthorized.js
import React from "react";
import { useMsal } from "@azure/msal-react";
import { useDispatch } from "react-redux";
import { logoutUser } from "../actions/authActions"; // Import the logout action

const Unauthorized = () => {
  const { instance } = useMsal(); // Get the MSAL instance from the MSAL hook
  const dispatch = useDispatch(); // Initialize the Redux dispatch

  const handleLogout = () => {
    // First, dispatch the Redux action to clear the user's session in your app
    dispatch(logoutUser());

    // Then, log the user out from Azure AD B2C
    instance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin, // Redirects back to the application after logout
    });
  };

  return (
    <div style={styles.container}>
      <img className="lostPageImage" src="/images/401.svg" alt="Unauthorized Access" />
      <p className="lostPagePara" style={styles.text}>
      You are not assigned to an Organization
        <p>Contact Admin</p>
      </p>
      <button onClick={handleLogout} style={styles.button}>
        Logout
      </button>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    textAlign: "center",
    fontFamily: "Arial, sans-serif",
  },
  text: {
    fontSize: "1.5rem",
    position: "relative",
    top: "40px",
    color: "#666",
  },
  button: {
    fontSize: "1.2rem",
    color: "#fff",
    backgroundColor: "#007BFF",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    textDecoration: "none",
    position: "relative",
    top: "50px",
   
  },
};

export default Unauthorized;
